import { render, staticRenderFns } from "./tc-modes.vue?vue&type=template&id=6d7b3044&"
import script from "./tc-modes.vue?vue&type=script&lang=js&"
export * from "./tc-modes.vue?vue&type=script&lang=js&"
import style0 from "./tc-modes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports